import { Base, createApp, importWhenVisible } from '@studiometa/js-toolkit';
import { Panel, Accordion } from '@studiometa/ui';
import Header from './organisms/Header.js';
import Video from './atoms/Video.js';
import FormProduct from './organisms/FormProduct.js';
import AddCrossSell from './atoms/AddCrossSell.js';
import Slider from './molecules/Slider.js';
import AvisClients from './organisms/AvisClients.js';
import ScrollTop from './atoms/ScrollTop.js';
import Roadmap from './organisms/Roadmap.js';

/**
 * App
 */
class App extends Base {
  /**
   * App Configuration
   */
  static config = {
    name: 'App',
    components: {
      Header,
      MultipleImages: (app) =>
        importWhenVisible(() => import('./molecules/MultipleImages.js'), 'MultipleImages', app),
      TagMaker: (app) => importWhenVisible(() => import('./atoms/TagMaker.js'), 'TagMaker', app),
      FormProduct,
      Video,
      Panel,
      Accordion,
      AddCrossSell,
      Slider,
      ScrollTop,
      AvisClients,
      ListingMap: (app) =>
        importWhenVisible(() => import('./organisms/ListingMap/index.js'), 'ListingMap', app),
      '.page-roadmap': Roadmap,
    },
  };

  cart = null;

  score = null;

  totalReviews = null;

  trustpilotApiUrl = `https://api.trustpilot.com/v1/business-units/641ac7df32bc3e5e965392d5`;

  /**
   * Log a nice message when app is ready.
   * @returns {void}
   */
  mounted() {
    this.cart = document.querySelector('cart-drawer');
    console.log(this.$children);
  }

  /**
   * addToCart
   * @param {number|string} id
   */
  addToCart(id) {
    if (this.cart === null) {
      this.cart = document.querySelector('cart-drawer');
    }

    document.body.classList.add('is-adding-to-cart');

    try {
      fetch(`${window.Shopify.routes.root}cart/add`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [
            {
              quantity: 1,
              id,
            },
          ],
        }),
      })
        .then((response) => {
          if (response.status === 200) {
            return response.text();
          }
          return false;
          // @todo handle response with errors, like out of stock
        })
        .then((response) => {
          // Call the function from cart-drawer.js to update the cart content and cart count and open the drawer
          this.cart.renderContents(response);
          document.body.classList.remove('is-adding-to-cart');
          if (this.cart && this.cart.classList.contains('is-empty'))
            this.cart.classList.remove('is-empty');
          this.$root.$update();
        });
    } catch {
      document.body.classList.remove('is-adding-to-cart');
    }
  }
}

export default createApp(App, document.body);
